export default __webpack_public_path__ + "locales/zh-CN/ConnectDialog.json?hash=eef39c6b500c08e166add1cb10c700dd";